import formatDate from '@/helpers/formatDate';

const pad = (n: number): string => String(n).padStart(2, '0');

export const utcNow = (): string => {
  const d = new Date();
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(
    d.getUTCDate()
  )} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`;
};

export const fmtTime = (dt: string | null): string => {
  if (!dt) return '';
  return formatDate(dt, 'HH:mm', false, false);
};

export const parseUtcMs = (dt: string): number =>
  Date.parse(dt.replace(' ', 'T') + 'Z');
